import React, {useState} from 'react';

import classNames from 'classnames';

import {Button, IButtonProps} from '../button';
import {Grid, GridColumn} from '../grid';
import {INavigationProps, Navigation} from '../navigation';
import {IUserProps, User} from './../user';
import {Filter, IFilterProps, Select} from './../forms';
import Datepicker, {IDatepickerRangeProps} from '../forms/datepicker/datepicker';
import {IPageSelectProps} from '../../modules';

export interface ISidemenuProps {
    navigation: INavigationProps;
    user: IUserProps;
    toggle: IButtonProps;
    className?: string;
    defaultIsOpen?: boolean;
    isOpen?: boolean;
    onChange?: (isOpen: boolean) => void;
    footer?: JSX.Element | string;
    languages?: IFilterProps;
    schedule?: IFilterProps;
    questionsFrequency?: IFilterProps;
    answerContext?: IFilterProps;
    channel?: IFilterProps;
    isUserActive?: IFilterProps;
    timezone?: IPageSelectProps | undefined;
    vacationCalendar?: IDatepickerRangeProps
    futureVacationRange?: string;
    cancelFutureVacationButton?: IButtonProps
}

const Sidemenu = (props: ISidemenuProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>(props.defaultIsOpen || false);

    const open: boolean = typeof props.isOpen !== 'undefined' ? props.isOpen : isOpen;

    const className: string = classNames(
        'sidemenu',
        {
            'is-open': open,
        },
        props.className,
    );

    const handleToggle: () => void = () => {
        if (typeof props.isOpen === 'undefined') {
            setIsOpen(!isOpen);
        }

        if (props.onChange) {
            props.onChange(!open);
        }
    };

    const close: () => void = () => {
        if (typeof props.isOpen === 'undefined') {
            setIsOpen(false);
        }

        if (props.onChange) {
            props.onChange(false);
        }
    };

    return (
        <aside className={className}>
            <div className="sidemenu__backdrop" onClick={close} />
            <div className="sidemenu__inner">
                <div className="sidemenu__top">
                    <Grid align={['middle-xs']}>
                        <GridColumn width={['max-xs']}>
                            <User {...props.user} className="sidemenu__user" />
                        </GridColumn>
                        <GridColumn width={['min-xs']}>
                            <Button
                                {...props.toggle}
                                color="white"
                                icon="close"
                                onClick={handleToggle}
                                style="square"
                            />
                        </GridColumn>
                    </Grid>
                </div>
                <div className="sidemenu__main">
                    <Navigation
                        {...props.navigation}
                        className="sidemenu__navigation"
                        direction="vertical"
                        onItemClick={(): void => close()}
                    />
                    {(props.languages || props.schedule || props.questionsFrequency || props.vacationCalendar || props.channel || props.answerContext) &&
                        <div className="sidemenu__settings text">
                            <div>
                                {props.languages && <Filter {...props.languages} className="sidemenu__filter" />}
                                {props.schedule && <Filter {...props.schedule} className="sidemenu__filter" />}
                                {props.questionsFrequency && <Filter {...props.questionsFrequency} className="sidemenu__filter" />}
                                {props.answerContext && <Filter {...props.answerContext} className="sidemenu__filter" />}
                                {props.channel && <Filter {...props.channel} className="sidemenu__filter" />}
                                {props.isUserActive && <Filter {...props.isUserActive} className="sidemenu__filter"/>}
                            </div>
                            <div>
                                {props.vacationCalendar && <Datepicker {...props.vacationCalendar}/>}
                            </div>
                            <div>
                                {props.timezone && <Select {...props.timezone} style={'borderless'}/>}
                            </div>
                            <Grid className="sidemenu__daterange-display">
                                <GridColumn width={['max-xs']}>
                                    {props.futureVacationRange}
                                </GridColumn>
                                <GridColumn width={['min-xs']}>
                                    {props.cancelFutureVacationButton && <Button {...props.cancelFutureVacationButton} icon={'x-red'} color={'white'}/>}
                                </GridColumn>
                            </Grid>
                        </div>
                    }
                </div>
                {props.footer &&
                    <div className="sidemenu__footer">
                        {props.footer}
                    </div>
                }
            </div>
        </aside>
    );
};

export default Sidemenu;
